import styled from 'styled-components'
import type { FunctionComponent, ReactNode } from 'react'
import { StyledH4 as H4 } from '../../stylesNew'

const StyledSpan = styled.span`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.25rem;

  & svg {
    width: 40px;
    height: 40px;
  }
`

const StyledH4 = styled(H4)`
  display: flex;
  margin-bottom: 2.5rem;
  align-items: center;
  font-size: 1.75rem;
  @media screen and (min-width: 48rem) {
    font-size: 2rem;
  }
`

interface SearchHeadingProps {
  label?: string
  icon?: ReactNode
}

const SearchHeading: FunctionComponent<SearchHeadingProps> = ({ label, icon }) => (
  <StyledH4 data-testid="searchHeading">
    <StyledSpan>{icon}</StyledSpan>
    {label}
  </StyledH4>
)

export default SearchHeading
